/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamHealthDashboard_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly primaryTeam: ({
        readonly __typename: "Team";
        readonly teamId: string;
        readonly teamName: string;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly userTeams: {
        readonly __typename: "TeamList";
        readonly list: ReadonlyArray<{
            readonly teamId: string;
        }>;
        readonly " $fragmentRefs": FragmentRefs<"TeamPickerWithActions_userTeams">;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly teamHealthScoreForTeamErrorable?: ({
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
    } | {
        readonly __typename: "TeamHealthScore";
        readonly myFocusTimeScore: {
            readonly calendarId: string | null;
            readonly totalMinutes: number | null;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_calendarFocusTimeScore">;
        } | null;
        readonly calendarFocusTimeScores: ReadonlyArray<{
            readonly calendarId: string | null;
            readonly totalMinutes: number | null;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_calendarFocusTimeScore">;
        } | null> | null;
        readonly profileTimeZones: ReadonlyArray<{
            readonly calendarId: string | null;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_profileTimeZone" | "TeammateAnalyticsCard_currentUserTimeZone">;
        } | null> | null;
        readonly persons: {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
        } | {
            readonly __typename: "PersonList";
            readonly list: ReadonlyArray<{
                readonly primaryEmail: string;
                readonly emails: ReadonlyArray<string>;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly isYou: boolean;
                readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_person">;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly orgPersons: {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
        } | {
            readonly __typename: "OrgPersonList";
            readonly list: ReadonlyArray<{
                readonly primaryCalendarId: string;
                readonly calendarAliases: ReadonlyArray<string>;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly isYou: boolean;
                readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_orgPerson">;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null | undefined;
    readonly teamHealthScoreJustForUserErrorable: ({
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
    } | {
        readonly __typename: "TeamHealthScore";
        readonly myFocusTimeScore: {
            readonly calendarId: string | null;
            readonly totalMinutes: number | null;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_calendarFocusTimeScore">;
        } | null;
        readonly calendarFocusTimeScores: ReadonlyArray<{
            readonly calendarId: string | null;
            readonly totalMinutes: number | null;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_calendarFocusTimeScore">;
        } | null> | null;
        readonly profileTimeZones: ReadonlyArray<{
            readonly calendarId: string | null;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_profileTimeZone" | "TeammateAnalyticsCard_currentUserTimeZone">;
        } | null> | null;
        readonly persons: {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
        } | {
            readonly __typename: "PersonList";
            readonly list: ReadonlyArray<{
                readonly primaryEmail: string;
                readonly emails: ReadonlyArray<string>;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly isYou: boolean;
                readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_person">;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly teamCalendarStatusErrorable: {
        readonly __typename: "CalendarStatusList";
        readonly list: ReadonlyArray<{
            readonly calendarId: string;
            readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_calendarStatus">;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_org">;
    readonly " $refType": "TeamHealthDashboard_org";
};
export type TeamHealthDashboard_org$data = TeamHealthDashboard_org;
export type TeamHealthDashboard_org$key = {
    readonly " $data"?: TeamHealthDashboard_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamHealthDashboard_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/),
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v5 = {
        "kind": "Variable",
        "name": "rangeMax",
        "variableName": "rangeMax"
    } as any, v6 = {
        "kind": "Variable",
        "name": "rangeMin",
        "variableName": "rangeMin"
    } as any, v7 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v10 = [
        (v9 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMinutes",
            "storageKey": null
        } as any,
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeammateAnalyticsCard_calendarFocusTimeScore"
        } as any
    ], v11 = {
        "alias": null,
        "args": null,
        "concreteType": "CalendarFocusTimeScore",
        "kind": "LinkedField",
        "name": "myFocusTimeScore",
        "plural": false,
        "selections": (v10 /*: any*/),
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "CalendarFocusTimeScore",
        "kind": "LinkedField",
        "name": "calendarFocusTimeScores",
        "plural": true,
        "selections": (v10 /*: any*/),
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "concreteType": "ProfileTimeZone",
        "kind": "LinkedField",
        "name": "profileTimeZones",
        "plural": true,
        "selections": [
            (v9 /*: any*/),
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeammateAnalyticsCard_profileTimeZone"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeammateAnalyticsCard_currentUserTimeZone"
            }
        ],
        "storageKey": null
    } as any, v14 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "persons",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            (v14 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "primaryEmail",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "emails",
                                "storageKey": null
                            },
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "TeammateAnalyticsCard_person"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "PersonList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "hasTeams"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "rangeMax"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "rangeMin"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "teamId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "TeamHealthDashboard_org",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "teamName",
                                "storageKey": null
                            }
                        ],
                        "type": "Team",
                        "abstractKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v1 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "TeamPickerWithActions_userTeams"
                            }
                        ],
                        "type": "TeamList",
                        "abstractKey": null
                    },
                    (v4 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    (v5 /*: any*/),
                    (v6 /*: any*/),
                    (v7 /*: any*/)
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamHealthScoreJustForUserErrorable",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v8 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v11 /*: any*/),
                            (v12 /*: any*/),
                            (v13 /*: any*/),
                            (v17 /*: any*/)
                        ],
                        "type": "TeamHealthScore",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    (v7 /*: any*/)
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamCalendarStatusErrorable",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CalendarStatus",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v9 /*: any*/),
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "TeammateAnalyticsCard_calendarStatus"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "CalendarStatusList",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v3 /*: any*/),
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeammateAnalyticsCard_org"
            },
            {
                "condition": "hasTeams",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": null,
                        "args": [
                            (v5 /*: any*/),
                            (v6 /*: any*/),
                            {
                                "kind": "Variable",
                                "name": "teamId",
                                "variableName": "teamId"
                            },
                            (v7 /*: any*/)
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "teamHealthScoreForTeamErrorable",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v8 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v11 /*: any*/),
                                    (v12 /*: any*/),
                                    (v13 /*: any*/),
                                    (v17 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "orgPersons",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v14 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "OrgPerson",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "primaryCalendarId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "calendarAliases",
                                                                "storageKey": null
                                                            },
                                                            (v15 /*: any*/),
                                                            (v16 /*: any*/),
                                                            {
                                                                "args": null,
                                                                "kind": "FragmentSpread",
                                                                "name": "TeammateAnalyticsCard_orgPerson"
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "OrgPersonList",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "TeamHealthScore",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '1ccd7c687fcc6138805e324fdb19d9a4';
export default node;
